import {Spinner} from "react-bootstrap";

export default function SchedulerActionLabel({children, isLoading}) {
    return (
        <span className={`scheduler-action-label${isLoading ? " scheduler-action-label-loading" : ""}`}>
            <Spinner
                as="span"
                animation="border"
                size="sm"
                className={`scheduler-action-spinner${isLoading ? "" : " scheduler-action-spinner-hidden"}`}
                aria-hidden="true"
            />
            <span>{children}</span>
        </span>
    );
}
